import { useEffect } from 'react';

const suffix = ' | Workday Developers';

const useSetDocTitle = (title: string | string[]) => {
  useEffect(() => {
    if (title) document.title = buildTitle(title);
  }, [title]);
};

const buildTitle = (title: string | string[]) => {
  if (typeof title === 'string') {
    return title + suffix;
  }
  return title.join(' - ') + suffix;
};

export default useSetDocTitle;
